export default __webpack_public_path__ + "static/wizard-flash-200-fcc8b101a19f2324eedad940a8aa4aaf.gif";